import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

interface Props {
  onConfirm: (teacherId: number) => void;
  onDecline?: () => void;
}

export interface ConfirmModalRef {
  openModal: (teacherId: number) => void;
  closeModal: () => void;
}

const prefix = 'confirmModal';

const ConfirmModal = forwardRef<ConfirmModalRef, Props>(
  ({ onConfirm, onDecline }, ref) => {
    const { t } = useTranslation(
      TranslationsKeys.TEACHER_MANAGMENT_TEACHER_ACTIVATION,
    );
    const [teacherId, setTeacherId] = useState<number>();

    const [modal, setModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal(teacherId: number) {
        setTeacherId(teacherId);
        setModal(true);
      },
      closeModal() {
        setModal(false);
      },
    }));

    return (
      <Modal isOpen={modal} toggle={() => setModal(!modal)} size="lg">
        <div className="text-center" style={{ padding: '20px' }}>
          <Icon name="information" size={45} />
          <h1 className="text-dark fs-20 mt-3 mb-4">{t(`${prefix}.title`)}</h1>

          <p className="fs-16 lh-30 text-center">
            {t(`${prefix}.description`)}
          </p>

          <div className="d-flex justify-content-around">
            <Button
              outlined
              text={t(`${prefix}.cancel`)}
              onClick={() => {
                onDecline && onDecline();
                setModal(false);
              }}
            />
            <Button
              text={t(`${prefix}.confirm`)}
              onClick={() => {
                onConfirm(teacherId!);
                setModal(false);
              }}
            />
          </div>
        </div>
      </Modal>
    );
  },
);

export default ConfirmModal;
